import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { DocType } from '@tencent/docs-mime-types';
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { requestV1Cgi, RetCode } from "../data-source/network-request";
import { COLLABORATION_SPACE_KIND } from "../model/collaboration-space";
import { DEFAULT_CREATOR_DOMAIN, DEFAULT_DOMAIN_ID, DocPolicy, DocSource, DocStatus, DRIVE_FILE_KIND, DriveFileType } from "../model/drive-file";
import { DRIVE_FOLDER_KIND, FOLDER_ATTRIBUTE } from "../model/drive-folder";
import { UserRole } from "../model/permission";
import { SHORT_CUT_KIND } from "../model/shortcut";
import { UNKNOWN_USER_NICK } from "../model/user";
export var RevealRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(RevealRequest, _DriveRequest);
  var _super = _createSuper(RevealRequest);
  function RevealRequest() {
    _classCallCheck(this, RevealRequest);
    return _super.apply(this, arguments);
  }
  _createClass(RevealRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: "/api/link/location/query?xsrf=".concat(getXsrfToken()),
        data: {
          link_file_ids: params.ids
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      var _this = this;
      if (response.retcode !== RetCode.Success) {
        throw new DriveApiError({
          name: 'RevealResultError',
          message: response.msg,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
      return response.result.locations.map(function (_ref) {
        var locations = _ref.locations,
          path = _ref.path,
          is_star = _ref.is_star,
          is_owner = _ref.is_owner,
          is_in_shared = _ref.is_in_shared;
        return {
          self: path ? path.files.map(function (item) {
            return _this.getFileNode(item, is_star, is_owner);
          }) : [],
          shortcuts: locations.map(function (shortcut) {
            return shortcut.files.map(function (item) {
              return _this.getFileNode(item, is_star, is_owner);
            });
          }),
          isInShared: is_in_shared
        };
      });
    }

    // eslint-disable-next-line max-lines-per-function
  }, {
    key: "getFileNode",
    value: function getFileNode(item, isCollected, isOwnedByMe) {
      var _meta$policy, _meta$status, _meta$thumbnail_url, _meta$tencent_doc_url2;
      var meta = item.metadata;
      var ownerVipInfo = JSON.parse(meta.owner_vip_info || 'null');
      var fileNode = {
        kind: '',
        id: meta.file_id,
        title: meta.name,
        collaborationFlag: meta.collaboration_flag,
        createTs: timestamp(meta.create_time),
        creator: {
          uid: meta.creator,
          nick: UNKNOWN_USER_NICK
        },
        docType: DocType.Unknown,
        iconUrl: meta.icon_url,
        lastBrowseTs: timestamp(meta.access_time),
        lastDeleteTs: 0,
        lastModifyTs: timestamp(meta.modify_time),
        lastModifier: {
          uid: meta.modify_uid,
          nick: meta.modifier_nick
        },
        mimeType: item.mime_type,
        owner: {
          uid: meta.owner,
          nick: meta.owner_nick,
          avatarFrameUrl: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.avatar_frame_url,
          expiredStatus: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.expired_status,
          vipLevel: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.vip_level,
          renewalStatus: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.renewal_status
        },
        originParentId: null,
        parentId: meta.file_parent_id,
        thirdAppId: meta.source_appid,
        isOwnedByMe: isOwnedByMe
      };
      if (meta.link_file_id) {
        var _meta$tencent_doc_url;
        Object.assign(fileNode, {
          kind: SHORT_CUT_KIND,
          targetId: meta.link_file_id,
          url: (_meta$tencent_doc_url = meta.tencent_doc_url) !== null && _meta$tencent_doc_url !== void 0 ? _meta$tencent_doc_url : '',
          personalizeInfo: meta.personalize_info ? {
            background: meta.personalize_info.background,
            isExpire: meta.personalize_info.is_expire,
            titleColor: meta.personalize_info.title_color,
            mode: meta.personalize_info.mode
          } : null
        });
        return fileNode;
      }
      if (meta.is_folder && meta.collaboration_flag) {
        Object.assign(fileNode, {
          kind: COLLABORATION_SPACE_KIND,
          attribute: null,
          roleId: UserRole.Unauthorized
        });
        return fileNode;
      }
      if (meta.is_folder) {
        Object.assign(fileNode, {
          kind: DRIVE_FOLDER_KIND,
          // 目前只能搜到自己的数据，因此文件夹都有权限
          attribute: FOLDER_ATTRIBUTE
        });
        return fileNode;
      }
      Object.assign(fileNode, {
        kind: DRIVE_FILE_KIND,
        ext: meta.ext,
        clientId: meta.client_id || null,
        // 空字符串 fallback 到 null
        creatorDomainId: DEFAULT_CREATOR_DOMAIN,
        domainId: DEFAULT_DOMAIN_ID,
        driveFileType: DriveFileType.CLOUD,
        groupChatKey: null,
        // 空字符串 fallback 到 null
        groupName: null,
        isCollected: isCollected,
        isPinned: null,
        lastCollectTs: 0,
        lastPinnedTs: 0,
        officialAuthInfo: meta.official_auth_info,
        personalizeInfo: meta.personalize_info ? {
          background: meta.personalize_info.background,
          isExpire: meta.personalize_info.is_expire,
          titleColor: meta.personalize_info.title_color,
          mode: meta.personalize_info.mode
        } : null,
        policy: (_meta$policy = meta.policy) !== null && _meta$policy !== void 0 ? _meta$policy : DocPolicy.Private,
        source: DocSource.Personal,
        status: (_meta$status = meta.status) !== null && _meta$status !== void 0 ? _meta$status : DocStatus.Normal,
        tenantId: meta.tenant_id || null,
        // 空字符串 fallback 到 null
        thumbnailUrl: (_meta$thumbnail_url = meta.thumbnail_url) !== null && _meta$thumbnail_url !== void 0 ? _meta$thumbnail_url : '',
        url: (_meta$tencent_doc_url2 = meta.tencent_doc_url) !== null && _meta$tencent_doc_url2 !== void 0 ? _meta$tencent_doc_url2 : '',
        weDriveInfo: meta.wedrive_info ? {
          docId: meta.wedrive_info.doc_id,
          docUrl: meta.wedrive_info.doc_url,
          fileId: meta.wedrive_info.file_id
        } : null
      });
      return fileNode;
    }
  }]);
  return RevealRequest;
}(DriveRequest);
function timestamp(input) {
  return Math.floor(Number(input) / 1000);
}
//# sourceMappingURL=reveal.js.map